import React from "./Contact.css"
import W from "../../images/whatsapp.png"
import F from "../../images/facebook.png"
import E from "../../images/gmail.png"
import { useEffect, useRef, useState } from "react"
import emailjs from '@emailjs/browser';

const Contact = () => {
  const formRef = useRef(null)
  const [success,setSuccess] = useState(false)

  //setting timeout for success to dissapear after 3 seconds
  useEffect(() => {
    let timer;
    if(success){
      timer = setTimeout(() => {
        setSuccess(false)
      },3000)
    }
    return () => clearTimeout(timer)
  },[success])

  //resetting placeholders to their original state
  useEffect(() => {
    //store the placeholders in a data-placehlder attribute
    Array.from(formRef.current.elements).forEach(input => {
      input.setAttribute("data-placeholder",input.placeholder)
    })
  },[])

  const handleSubmit = async (e) => {
    e.preventDefault()
    //sending email from emailjs
    emailjs.sendForm('service_9n40nxq', 'template_n1yqlal', formRef.current, 'pqzQzmMfhs-7O63-G')
    .then((result) => {
        console.log(result.text);
        setSuccess(true)
    }, (error) => {
        console.log(error.text);
        setSuccess(false)
    });
    //clearing the placeholders by setting the placeholder attribute to an empty string
    Array.from(formRef.current.elements).forEach((input) => {
      input.placeholder = input.getAttribute("data-placeholder")
    })
    //reset the form fields by calling the reset function on the form's DOM node
    formRef.current.reset()
  }

  return (
    <div className="contact">
      <div className="contactContainer">
        <div className="contactLeft">
          <form onSubmit={handleSubmit} ref={formRef}>
            <label htmlFor="name">Name:</label>
            <input type="text" placeholder="Enter Full Name" name="name" id="name"/>
            <label htmlFor="phone">Phone No:</label>
            <input type="text" placeholder="Enter phone no.." name="phone" id="email"/>
            <label htmlFor="message">Message:</label>
            <textarea type="text" placeholder="type message here..." rows="5" name="message" id="message"/>
            <button className="submit" type="submit">Send</button>
            {success && <div className="success">Message send,we'll get back to you shortly through your number</div> }
          </form>
        </div>
        <div className="contactRight">
          <div className="socialContainer">
            <div className="socialItem">
              <img src={W} alt="" className="socialIcon" />
              <a href="whatsapp://send?phone=+254710535097" target="_blank" rel="noreferrer">Chat</a>
            </div>
            <div className="socialItem">
            <img src={F} alt="" className="socialIcon" />
            <a href="https://www.facebook.com/HomelandIrrigation" target="_blank" rel="noreferrer">Message</a>
            </div>
            <div className="socialItem">
            <img src={E} alt="" className="socialIcon" />
            <a href="mailto:homelandirrigation1@gmail.com" target="_blank" rel="noreferrer">send mail</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact